package fr.arcplex.network

/** Coherence API base URL: proxied through the web box on web platforms. */
actual val defaultCoherenceBaseUrl: String = "/coherence-api"

/** TLS belongs to the browser on web, so the QA escape hatch is always off. */
actual fun insecureTlsRequestedByEnvironment(): Boolean = false
